import { EnumUnit } from './Generated';
import { GroupedSelectOption } from '@synqo/frontend-component-library';

export const getEnumUnitLabel = (value: EnumUnit) => {
    switch (value) {
        case EnumUnit.Numerable:
            return 'Stück';
        case EnumUnit.FixedFee:
            return 'Pauschal';
        case EnumUnit.Percent:
            return 'Prozent';
        case EnumUnit.Kilogram:
            return 'Kilogram';
        case EnumUnit.Ton:
            return 'Tonnen';
        case EnumUnit.Gram:
            return 'Gramm';
        case EnumUnit.Liter:
            return 'Liter';
        case EnumUnit.CubicMeter:
            return 'Kubik-Meter';
        case EnumUnit.Hours:
            return 'Stunden';
        case EnumUnit.Days:
            return 'Tage';
        case EnumUnit.Kilometers:
            return 'Kilometer';
        default:
            return 'Nicht definiert';
    }
};

export const getShortUnitLabel = (value: EnumUnit): string => {
    switch (value) {
        case EnumUnit.Numerable:
            return 'Stk.';
        case EnumUnit.FixedFee:
            return 'pausch.';
        case EnumUnit.Percent:
            return '%';
        case EnumUnit.Kilogram:
            return 'kg';
        case EnumUnit.Ton:
            return 't';
        case EnumUnit.Gram:
            return 'g';
        case EnumUnit.Liter:
            return 'l';
        case EnumUnit.CubicMeter:
            return 'm³';
        case EnumUnit.Hours:
            return 'h';
        case EnumUnit.Days:
            return 'd';
        case EnumUnit.Kilometers:
            return 'km';
        default:
            return 'n.d.';
    }
};

export const unitOptions: GroupedSelectOption<EnumUnit>[] = [
    {
        name: 'weights',
        label: 'Gewichte',
        value: [
            { name: 'tons', label: getEnumUnitLabel(EnumUnit.Ton), value: EnumUnit.Ton },
            { name: 'kilogram', label: getEnumUnitLabel(EnumUnit.Kilogram), value: EnumUnit.Kilogram },
            { name: 'gram', label: getEnumUnitLabel(EnumUnit.Gram), value: EnumUnit.Gram },
        ],
    },
    {
        name: 'volumnes',
        label: 'Volumen',
        value: [
            { name: 'liter', label: getEnumUnitLabel(EnumUnit.Liter), value: EnumUnit.Liter },
            { name: 'cubicmeter', label: getEnumUnitLabel(EnumUnit.CubicMeter), value: EnumUnit.CubicMeter },
        ],
    },
    {
        name: 'times',
        label: 'Zeiten',
        value: [
            { name: 'hours', label: getEnumUnitLabel(EnumUnit.Hours), value: EnumUnit.Hours },
            { name: 'days', label: getEnumUnitLabel(EnumUnit.Days), value: EnumUnit.Days },
        ],
    },
    {
        name: 'distances',
        label: 'Entfernungen',
        value: [{ name: 'kilometers', label: getEnumUnitLabel(EnumUnit.Kilometers), value: EnumUnit.Kilometers }],
    },
    { name: 'numerable', label: getEnumUnitLabel(EnumUnit.Numerable), value: EnumUnit.Numerable },
    { name: 'fixed_fee', label: getEnumUnitLabel(EnumUnit.FixedFee), value: EnumUnit.FixedFee },
    { name: 'percent', label: getEnumUnitLabel(EnumUnit.Percent), value: EnumUnit.Percent },
];

export const shortUnitOptions: GroupedSelectOption<EnumUnit>[] = [
    {
        name: 'weights',
        label: 'Gewichte',
        value: [
            { name: 'tons', label: getShortUnitLabel(EnumUnit.Ton), value: EnumUnit.Ton },
            { name: 'kilogram', label: getShortUnitLabel(EnumUnit.Kilogram), value: EnumUnit.Kilogram },
            { name: 'gram', label: getShortUnitLabel(EnumUnit.Gram), value: EnumUnit.Gram },
        ],
    },
    {
        name: 'volumes',
        label: 'Volumen',
        value: [
            { name: 'liter', label: getShortUnitLabel(EnumUnit.Liter), value: EnumUnit.Liter },
            { name: 'cubicmeter', label: getShortUnitLabel(EnumUnit.CubicMeter), value: EnumUnit.CubicMeter },
        ],
    },
    {
        name: 'times',
        label: 'Zeiten',
        value: [
            { name: 'hours', label: getShortUnitLabel(EnumUnit.Hours), value: EnumUnit.Hours },
            { name: 'days', label: getShortUnitLabel(EnumUnit.Days), value: EnumUnit.Days },
        ],
    },
    {
        name: 'distances',
        label: 'Entfernungen',
        value: [{ name: 'kilometers', label: getShortUnitLabel(EnumUnit.Kilometers), value: EnumUnit.Kilometers }],
    },
    { name: 'numerable', label: getShortUnitLabel(EnumUnit.Numerable), value: EnumUnit.Numerable },
    { name: 'fixed_fee', label: getShortUnitLabel(EnumUnit.FixedFee), value: EnumUnit.FixedFee },
    { name: 'percent', label: getShortUnitLabel(EnumUnit.Percent), value: EnumUnit.Percent },
];
